import { lazy } from 'react'

export const LazyReportErrorDialog = lazy(async () => {
  const { ReportErrorDialog } = await import('#features/ErrorHandling/ReportErrorDialog.tsx')
  return { default: ReportErrorDialog }
})
